import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreMainTemplateComponent } from './templates/core-main-template/core-main-template.component';
import { CoreRoutes } from './routes/core.routes';
import { HomeRoutes } from '../home/routes/home.routes';
import { RoleGuard } from '../auth/guards/role.guard';
import { accountGuard } from '../account/guards/account.guard';
import { dictionaryResolver } from '../dictionary/resolvers/dictionary.resolver';

const routes: Routes = [
  {
    path: CoreRoutes.main,
    component: CoreMainTemplateComponent,
    canActivate: [accountGuard],
    children: [
      {
        path: HomeRoutes.root,
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('../home/home.module').then(m => m.HomeModule),
      },
    ],
  },
  {
    path: CoreRoutes.error,
    resolve: { dictionary: dictionaryResolver },
    loadComponent: () =>
      import('./views/core-error-view/core-error-view.component').then(
        m => m.CoreErrorViewComponent
      ),
  },
  {
    path: CoreRoutes.forbidden,
    resolve: { dictionary: dictionaryResolver },
    loadComponent: () =>
      import(
        './views/forbidden-error-view/forbidden-error-view.component'
      ).then(m => m.ForbiddenErrorViewComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
